var map = {
	"./adult/de/5 1 Leseforstaelse Intro.mp3": 841,
	"./adult/nn/5 1 Leseforstaelse Intro.mp3": 842,
	"./adult/no/5 1 Leseforstaelse Intro.mp3": 843,
	"./youth/de/5 1 Leseforstaelse Intro.mp3": 844,
	"./youth/nn/5 1 Leseforstaelse Intro.mp3": 845,
	"./youth/no/5 1 Leseforstaelse Intro.mp3": 846,
	"./youth/se/5 1 Leseforstaelse Intro.mp3": 847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 840;